export class UserHomeConstants {
    public static readonly UserHomeTopBarTitle = 'User Home';
    public static readonly UserHomeDocumentTitle = 'Document Control';
    public static readonly UserHomeTrainingTitle = 'Training';

    public static readonly UserHome_RoleAcessPermission_Fail: string = "Unable to fetch Roles permission";
}
